import {ConfigService} from "@config/config.service";
import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {BillingContractModel} from "@services/back-office/model/billingContractModel";
import {PaginationModel} from "@shared/models/pagination.model";
import {BillingContractSearchModel} from "@services/back-office/model/billingContractSearchModel";
import {ContractsActionTypes, ContractsActions} from '@billing/ngrx/actions/contracts.actions';

export const adapter: EntityAdapter<BillingContractModel> = createEntityAdapter<BillingContractModel>();

export interface State extends EntityState<BillingContractModel> {
    loading: boolean,
    pagination: PaginationModel,
    filter: BillingContractSearchModel,
    totalByPages?: number
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: new ConfigService().paginationConfig.pageSize,
        totalElements: 0,
    },
    totalByPages: 0,
    filter: { statuses: new Set(['CREATED']) }
});

export function reducer(state = initialState, action: ContractsActions): State {
    switch (action.type) {

        case ContractsActionTypes.LoadContracts:
            return {...state, loading: !action.payload?.dontShowLoading};
        case ContractsActionTypes.LoadContractsSuccess:
            return adapter.setAll(action.payload.content!, {
                ...state,
                loading: false,
                pagination: {
                    size: action.payload.size,
                    last: action.payload.last,
                    totalElements: action.payload.totalElements,
                    numberOfElements: action.payload.numberOfElements,
                    first: action.payload.first,
                    number: action.payload.number,
                },
                totalByPages: action.payload.totalByPages,
            });

        case ContractsActionTypes.LoadContractsFailure:
            return {...state, loading: false};

        case ContractsActionTypes.AddContractsFailure:
            return {...state};

        case ContractsActionTypes.EditContracts:
            return {...state};

        case ContractsActionTypes.EditContractsSuccess:
        case ContractsActionTypes.UpdateContractSuccess:
            return adapter.updateOne({id: action.payload.id!, changes: action.payload}, {...state});

        case ContractsActionTypes.DeleteContractsSuccess:
            return adapter.removeOne(action.payload, {
                ...state,
                pagination: {
                    ...state.pagination,
                    numberOfElements: state.pagination.numberOfElements !== 0 ? state.pagination.numberOfElements! - 1 : 0
                }
            });

        case ContractsActionTypes.ChangePage:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    number: action.payload.number,
                    size: action.payload.size
                }
            };

        case ContractsActionTypes.SetInitialPagination:
            return {...state, pagination: initialState.pagination};

        case ContractsActionTypes.SetFilter:
            return {...state, filter: action.payload};

        case ContractsActionTypes.ClearFilter:
            return {...initialState, filter: {}};

        default:
            return state;
    }
}

export const {
    selectIds: selectContractsIds,
    selectAll: selectAllContracts
} = adapter.getSelectors();
